export const profilTypes = {
    PROFIL_LOADING : "PROFIL_LOADING",
    PROFIL_DETAIL_LOADING : "PROFIL_DETAIL_LOADING",
    PROFIL_CREATE_LOADING : "PROFIL_CREATE_LOADING",
    PROFIL_CREATE : "PROFIL_CREATE",
    GET_ALL_PROFIL : "GET_ALL_PROFIL",
    GET_SELECTED_PROFIL : "GET_SELECTED_PROFIL",
};
  
  